import React from "react";
import ProjectList from "./ProjectList";

const PANELS = {
	projects: {
		title: "dsi.export-templates-management.panel.projects.title",
		panel: ({ companyId, templateId, projectsRequest, onUpdateRow }) => (
			<ProjectList
				companyId={companyId}
				projectsRequest={projectsRequest}
				templateId={templateId}
				onUpdateRow={onUpdateRow}
			/>
		),
	},
};

export default PANELS;
